import apiRequest from '../apis/api-request';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const authService = {

    login: async (data) => {
        return apiRequest({
            method: "POST",
            url: `/api/user/login`,
            data: data
        });
    },

    createUser: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "POST",
            url: `/api/user`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    updateUser: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "PUT",
            url: `/api/user`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    userList: async (data) => {
        const token = selectAuthToken(store.getState());
        const search = data?.search ? data?.search : '';
        const dept_id = data?.department ? data?.department : '';
        const size = data?.size ? data?.size : 25;
        const page = data?.page ? data?.page : 0;
        return apiRequest({
            method: "GET",
            url: `/api/user/all?search=${search}&dept_id=${dept_id}&size=${size}&page=${page}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    changePassword: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "PATCH",
            url: `/api/user/change_password`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    deleteUser: async (id) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "DELETE",
            url: `/api/user/${id}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    }

};

export default authService;